export const SHORT_MESSAGE_CHANNELS = {
  EMPTY_VOICE_CHANNEL_INPUT_ERROR_MESSAGE: {
    key: 'EMPTY_VOICE_CHANNEL_INPUT_ERROR_MESSAGE',
    value: 'Voice message is empty',
  },
  EMPTY_CHANNELS_INPUT_ERROR_MESSAGE: {
    key: 'EMPTY_CHANNELS_INPUT_ERROR_MESSAGE',
    value: 'All three channels are Empty!',
  },
  WHATSAPP_MESSAGE_CHANNEL_TAB_NAME: {
    key: 'WHATSAPP_MESSAGE_CHANNEL_TAB_NAME',
    value: 'WhatsApp',
  },
  VOICE_MESSAGE_CHANNEL_TAB_NAME: {
    key: 'VOICE_MESSAGE_CHANNEL_TAB_NAME',
    value: 'Voice message',
  },
  SMS_CHANNEL_TAB_NAME: {
    key: 'SMS_CHANNEL_TAB_NAME',
    value: 'SMS',
  },
  WHATSAPP_MESSAGE_CHANNEL_NAME: {
    key: 'WHATSAPP_MESSAGE_CHANNEL',
    value: 'Whatsapp',
  },
  VOICE_MESSAGE_CHANNEL_NAME: {
    key: 'VOICE_MESSAGE_CHANNEL',
    value: 'Call',
  },
  VOICE_MESSAGE_CHANNEL_PLACEHOLDER: {
    key: 'VOICE_MESSAGE_CHANNEL_PLACEHOLDER',
    value: 'Write something here ...',
  },
  SMS_CHANNEL_NAME: {
    key: 'SMS_CHANNEL',
    value: 'Message',
  },
  WHATSAPP_CHANNEL_MESSAGE: {
    key: 'WHATSAPP_CHANNEL_MESSAGE',
    value: 'Whatsapp message',
  },
  VOICE_CHANNEL_MESSAGE: {
    key: 'VOICE_CHANNEL_MESSAGE',
    value: 'Voice message',
  },
  SMS_CHANNEL_MESSAGE: {
    key: 'SMS_CHANNEL_MESSAGE',
    value: 'SMS',
  },
  UPDATING_CHANNEL_MESSAGE: {
    key: 'UPDATING_CHANNEL_MESSAGE',
    value: 'Updating',
  },
  CHANNEL_UPDATED_SUCCESS_MESSAGE: {
    key: 'CHANNEL_UPDATED_SUCCESS_MESSAGE',
    value: 'updated successfully',
  },
  UNABLE_TO_UPDATE_CHANNEL_ERROR_MESSAGE: {
    key: 'UNABLE_TO_UPDATE_CHANNEL_ERROR_MESSAGE',
    value: 'Unable to update',
  },
  CHANNEL_CURRENT_DAY: {
    key: 'CHANNEL_CURRENT_DAY',
    value: 'Today',
  },
  WHATSAPP_MESSAGE_SEEN_BY_USER: {
    key: 'WHATSAPP_MESSAGE_SEEN_BY_USER',
    value: 'Seen',
  },
  SEND_TEST_MESSAGE_TOOLTIP: {
    key: 'SEND_TEST_MESSAGE_TOOLTIP',
    value: 'Send Test Message',
  },
  SEND_TEST_MESSAGE_BUTTON: {
    key: 'SEND_TEST_MESSAGE_BUTTON',
    value: 'Send Test Message',
  },
  MAXIMUM_ALLOWED_CHARACTERS_INFO: {
    key: 'MAXIMUM_ALLOWED_CHARACTERS_INFO',
    value: `Max {{maxChar}} Characters`,
  },
  MAXIMUM_ALLOWED_CHARACTERS_MESSAGE: {
    key: 'MAXIMUM_ALLOWED_CHARACTERS_MESSAGE',
    value: 'Max {{maxChar}} Characters',
  },
  CHAR_LIMIT_EXCEEDED_ERROR: {
    key: 'CHAR_LIMIT_EXCEEDED_ERROR',
    value: 'Character limit exceeded',
  }
};

export const UPDATE_DATE_VARIABLE_FORMAT_POPUP = {
  DATE_FORMAT_LABEL: { key: 'DATE_FORMAT_LABEL', value: 'Date format' },
  CANCEL_UPDATE_DATE_VARIABLE_FORMAT_BUTTON: {
    key: 'CANCEL_UPDATE_DATE_VARIABLE_FORMAT_BUTTON',
    value: 'Cancel',
  },
  SAVE_UPDATE_DATE_VARIABLE_FORMAT_BUTTON: {
    key: 'SAVE_UPDATE_DATE_VARIABLE_FORMAT_BUTTON',
    value: 'Save',
  },
};
